export const toTop = () => {
  document?.querySelector(".mainContentLayout")?.scrollTo(0, 0);
  setTimeout(() => {
    document?.querySelector(".mainContentLayout")?.scrollTo(0, 0);
  }, 100);
};
